import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createSaleOrdEntry = createAsyncThunk('createSaleOrdEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSaleOrder`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateSaleOrder = createAsyncThunk('updateSaleOrder', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateSaleOrder`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertSOrateQuotation = createAsyncThunk('insertSOrateQuotation', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSOrateQuotation`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertSOquotwise = createAsyncThunk('insertSOquotwise', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=InsertSOQuotationWise`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOQuotationlist = createAsyncThunk('fetchSOQuotationlist', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOQuotationlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const getQuotationEntryNo = createAsyncThunk(
  'getQuotationEntryNo',
  async (partyId) => {

    const response = await axios.get(
      `${baseUrl}?apicall=getQuotationEntryNo&partyId=${partyId}`
    );
    console.log("qt reponse data=>",response.data);
    return response.data;
  }
);
export const getMultiQuotationEntryNo = createAsyncThunk('getMultiQuotationEntryNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMultiQuotationEntryNo`);
        
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSaleOrder = createAsyncThunk('fetchSaleOrder', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSaleOrderlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const getPartyList = createAsyncThunk('getPartyList', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPartyAsperSOFirm&firmId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSaleBarcode = createAsyncThunk('fetchSaleBarcode', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSoBarcode`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOno = createAsyncThunk('fetchSOno', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOno`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSORegister = createAsyncThunk('fetchSORegister', async (id) => {
    try {
        const endpoint = id ? `getSOlist&soId=${id}` : 'getSOlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        console.log("so reponse api=>",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const fetchSOSampleRegister = createAsyncThunk('fetchSOSampleRegister', async (id) => {
    try {
        const endpoint = id ? `getSOSamplelist&soId=${id}` : 'getSOSamplelist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        console.log("so reponse api=>",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const fetchSORegister1 = createAsyncThunk('fetchSORegister1', async (id) => {
    try {
        const endpoint = id ? `getSOlistNew&soId=${id}` : 'getSOlistNew';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        //console.log("sonew reponse api=>",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchSORegister2 = createAsyncThunk('fetchSORegister2', async (id) => {
    try {
        const endpoint = id ? `getSOlist&sono=${id}` : 'getSOlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOinfolist = createAsyncThunk('fetchSOinfolist', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOinfolist&soId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOnoInfolist = createAsyncThunk('fetchSOnoInfolist', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOinfolist&sono=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteSingleSaleOrd = createAsyncThunk('deleteSingleSaleOrd', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteSaleOrder&sono=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const getPartyFromSingleQt = createAsyncThunk(
  'getPartyFromSingleQt',
  async (quotId) => {
    const response = await axios.get(
      `${baseUrl}?apicall=getPartyFromQuotation&quotId=${quotId}`
    );
    return response.data;
  }
);

export const getPartyFromMultiQt = createAsyncThunk(
  'getPartyFromMultiQt',
  async ({ quotId, mqtNo }) => {
    const response = await axios.get(
      `${baseUrl}?apicall=getPartyFromMultiQuotation&quotId=${quotId}&mqtNo=${mqtNo}`
    );
    return response.data;
  }
);


const saleOrderSlice = createSlice({
    name: 'SaleOrderData',
    initialState: {
        isLoading: false,
        saleorder: null,
        barcode: null,
        deleteSale: null,
        sono: null,
        soquot: null,
        qtEntry: null,
        mqtEntry:null,
        partylist: null,
        solist: null,
        solist1:null,
        sosamplelist:null,
        soinfo: null,
        sonolist: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSaleOrder.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSaleOrder.fulfilled, (state, action) => {
            state.isLoading = false;
            state.saleorder = action.payload;
        });
        builder.addCase(fetchSaleOrder.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSaleBarcode.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSaleBarcode.fulfilled, (state, action) => {
            state.isLoading = false;
            state.barcode = action.payload;
        });
        builder.addCase(fetchSaleBarcode.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSOno.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOno.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sono = action.payload;
        });
        builder.addCase(fetchSOno.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(deleteSingleSaleOrd.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleSaleOrd.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteSale = action.payload;
        });
        builder.addCase(deleteSingleSaleOrd.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSOQuotationlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOQuotationlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.soquot = action.payload;
        });
        builder.addCase(fetchSOQuotationlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(getQuotationEntryNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getQuotationEntryNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.qtEntry = action.payload;
        });
        builder.addCase(getQuotationEntryNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        
        builder.addCase(getMultiQuotationEntryNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getMultiQuotationEntryNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.mqtEntry = action.payload;
        });
        builder.addCase(getMultiQuotationEntryNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(getPartyList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getPartyList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.partylist = action.payload;
        });
        builder.addCase(getPartyFromSingleQt.fulfilled, (state, action) => {
    state.partylist = action.payload;
});

builder.addCase(getPartyFromMultiQt.fulfilled, (state, action) => {
    state.partylist = action.payload;
});
        builder.addCase(getPartyList.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSORegister.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSORegister.fulfilled, (state, action) => {
            state.isLoading = false;
            state.solist = action.payload;
        });
        builder.addCase(fetchSORegister.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

          builder.addCase(fetchSOSampleRegister.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOSampleRegister.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sosamplelist = action.payload;
        });
        builder.addCase(fetchSOSampleRegister.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
         builder.addCase(fetchSORegister1.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSORegister1.fulfilled, (state, action) => {
            state.isLoading = false;
            state.solist1 = action.payload;
        });
        builder.addCase(fetchSORegister1.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchSOinfolist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOinfolist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.soinfo = action.payload;
        });
        builder.addCase(fetchSOinfolist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchSOnoInfolist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOnoInfolist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sonolist = action.payload;
        });
        builder.addCase(fetchSOnoInfolist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSORegister2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSORegister2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.solist = action.payload;
        });
        builder.addCase(fetchSORegister2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default saleOrderSlice.reducer;
